import * as d3 from "d3";

// const fillColor = "#00c3ff";
const clickIgnore = ["speech", "bubble"];

const svgMixin = (slideNumber, svgClass, svgData) => ({
  mounted() {
    this.loadSVGData().then(svg => this.update(svg));
  },
  data() {
    return {
      svgObject: null
    }
  },
  methods: {
    async loadSVGData() {
      const svg = await import(`@/data/${svgData}`);
      const parsed = JSON.parse(JSON.stringify(svg))
      // debugger
      this.svgObject = JSON.parse(JSON.stringify(svg))
      // debugger
      return parsed.default.svgData;
    },
    update(data) {
      let that = this;
      d3.selectAll(svgClass).data(data, function(d) {

        if (!d) return d ? d.id : this.id;
        return d ? d.id : this.id;
      });

      d3.selectAll(svgClass)
        .on("click", function(d) {
          debugger
          let altD
          if (d == undefined) {
            // let svgData = JSON.parse(JSON.stringify(that.svgObject)).default.svgData
            let objId = this.className.animVal.slice(13)
            altD = JSON.parse(JSON.stringify(that.svgObject)).default.svgData.map(d => d).find(d => d.id.includes(objId))
            // altD = JSON.parse(JSON.stringify(that.svgObject)).default.svgData.map(d => d).find(d => d.id == objId)
            // altD = find and assign the object based on the class and svgdata
          } else {
            altD = d
          }
          // debugger
          let openModalBool = true;
          // if(!d) return;
          // we don't want to do anything w/ bubbles or speech here.
          if (clickIgnore.some(word => altD.id.includes(word))) {
            return;
          }
          if (altD.id.includes("avatar")) {
            that.toggleSpeech(slideNumber, altD.id);
            return;
          }
          if (d.url) {
            window.open(d.url, "_blank");
            return;
          }
          // if (altD.url) {
          //   const externalPrompt =
          //     "This will take you to an external website and open a new window or tab, but the current window will remain opened. Proceed?";
          //   if (window.confirm(externalPrompt)) {
          //     window.open(altD.url, "_blank");
          //     return;
          //   } else {
          //     openModalBool = false;
          //   }
          // }
          if (altD.url) {
            that.showUrlModal = true
            openModalBool = false
          }
          //to do: maybe check for things that shouldnt have a click event and return (like speech / bubble)
          // that.clickedItem = altD;
          that.clickedItem = JSON.parse(JSON.stringify(altD))
          that.modalBoolean = openModalBool;
        })

        // .on("mouseover", function(d) {
        //   // for labels that we don't create slide objects for. If hovered over, cause error.
        //   // best to check if undefined then proceed.
        //   if (!d) return;
        //   if (d.label) {
        //     d3.select(`#${d.label}`)
        //       .attr("stroke-width", 15)
        //       .attr("opacity", 1);
        //     d3.select(`#${d.id}`)
        //       .attr("fill", fillColor)
        //       .attr("fill-opacity", 0.3);
        //   }
        // })

        .on("mouseout", function(d) {
          // for labels that we don't create slide objects for. If hovered over, cause error.
          // best to check if undefined then proceed.
          if (!d) return;
          if (d.label) {
            // d3.select(`#${d.label}`).attr("opacity", 0);
            d3.select(`#${d.id}`).attr("fill-opacity", 0);
          }
        });

      d3.selectAll(".hide").attr("opacity", 0);
      //todo (minor): fix toggle for options 2 and 3
      const now = Date.now();
      const phohDate = new Date(2020, 8, 1);
      const dayAfterPhoh = new Date(2020, 8, 2);
      if (now < phohDate) {
        d3.selectAll("#slide8bubble1").attr("display", "inline");
        d3.selectAll("#slide8bubble2").attr("display", "none");
        d3.selectAll("#slide8bubble3").attr("display", "none");
      } else if (now >= phohDate && now < dayAfterPhoh) {
        d3.selectAll("#slide8bubble1").attr("display", "none");
        d3.selectAll("#slide8bubble2").attr("display", "inline");
        d3.selectAll("#slide8bubble3").attr("display", "none");
      } else {
        d3.selectAll("#slide8bubble1").attr("display", "none");
        d3.selectAll("#slide8bubble2").attr("display", "none");
        d3.selectAll("#slide8bubble3").attr("display", "inline");
      }
    },
    toggleSpeech(slide, id) {
      const number = id.slice(id.length - 1);
      const bubble = d3.select(`#slide${slide}bubble${number}`);
      const bubbleText = d3.select(`#slide${slide}bubble${number}text`);
      const opacity = bubble.style("opacity");
      const textOpacity = bubbleText.style("opacity");
      const toggledOpacity = 1 - opacity;
      const toggledTextOpacity = 1 - textOpacity;
      debugger
      bubble.attr("opacity", toggledOpacity);
      bubbleText.attr("opacity", toggledTextOpacity);
    },
    renderImage(image) {
      if (image.startsWith("http")) {
        return image;
      } else {
        return require(`../../public/static/Slide ${slideNumber}/${image}.jpg`);
      }
    }
  }
});

export default svgMixin;
